/* eslint-disable camelcase */
/* eslint-disable new-cap */
/* eslint-disable no-var */

import {Intercom, boot, shutdown, update} from "@intercom/messenger-js-sdk";
import {getAllowedCookiesFlag} from './util';

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID ?? ''

export const init = () => {
  if (INTERCOM_APP_ID && getAllowedCookiesFlag()) {
    Intercom({
      app_id: INTERCOM_APP_ID,
    });

    boot({
      app_id: INTERCOM_APP_ID,
      custom_launcher_selector: '.intercom-launcher',
    })
  }
}

export const identify = (userData) => {
  if (INTERCOM_APP_ID && userData?.company?.id && getAllowedCookiesFlag()) {
    update({
      user_id: userData.id,
      user_hash: userData.intercomHash,
      email: userData.email,
      name: `${userData.firstName} ${userData.lastName}`,
      created_at: new Date(userData.createdAt).getTime() / 1000,
      avatar: {
        type: 'avatar',
        image_url: `${userData.avatarFileUrl}?fit=crop&h=256&w=256`,
      },
      company: {
        company_id: userData.company.id,
        name: userData.company.officialName,
        website: userData.company.website,
        created_at: new Date(userData.company.createdAt).getTime() / 1000,
        is_client: Boolean(userData.company.isClientCompany),
        facility_processes: userData.company.facilityProcessNames,
      },
    })
  }
}

export const pageChange = () => {
  if (INTERCOM_APP_ID && getAllowedCookiesFlag()) update({})
}

export const logout = () => {
  if (INTERCOM_APP_ID && getAllowedCookiesFlag()) {
    shutdown()
    boot({
      app_id: INTERCOM_APP_ID,
    })
  }
}

export const shutDown = () => {
  if (INTERCOM_APP_ID && getAllowedCookiesFlag()) {
    shutdown()
  }
}
